module.exports = __webpack_public_path__ + "static/media/cloud-download-alt.df2f70bf.svg";